import { serialize } from './historyUtils.js'
import { getOptionalFunctionUrlOverride } from './functionEndpoints.js'
import {
  createHttpError,
  withRefreshedAccessTokenRetry,
} from './googleAuthSession.js'

const APPEND_SHEET_VALUES_URL =
  getOptionalFunctionUrlOverride(
    process.env.REACT_APP_APPEND_SHEET_VALUES_URL,
    'append-sheet-values'
  );

export const appendAndClear = async (
  history,
  spreadsheetAccessData,
  guid,
  reviewMetadata = []
) => {
  try {
    console.log('attempting update')
    const resp = await withRefreshedAccessTokenRetry(
      spreadsheetAccessData,
      async (nextAccessData) => {
        let req = await fetch(APPEND_SHEET_VALUES_URL, {
          body: JSON.stringify({
            ...nextAccessData,
            range: 'history!A1:T1',
            values: history.map(x => serialize(x)),
            local_user_id: guid,
            review_metadata: reviewMetadata
          }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const responseText = await req.text();
        let nextResponse = null;
        if (responseText) {
          try {
            nextResponse = JSON.parse(responseText);
          } catch (parseError) {
            nextResponse = null;
          }
        }
        if (!req.ok) {
          throw createHttpError(
            nextResponse?.message ||
            nextResponse?.error ||
            responseText ||
            `append-sheet-values failed with status ${req.status}`,
            req.status,
            nextResponse
          );
        }
        if (!nextResponse?.updates) {
          throw new Error('append-sheet-values returned a non-JSON or incomplete success response');
        }
        return nextResponse;
      }
    );
    /*{"spreadsheetId":"1_4k2ElXY4Clrj_ASDeU0gGXGy5H6CXCEikPeymu80iE","tableRange":"history!A1:Q2746","updates":{"spreadsheetId":"1_4k2ElXY4Clrj_ASDeU0gGXGy5H6CXCEikPeymu80iE","updatedRange":"history!A2747:Q2756","updatedRows":10,"updatedColumns":17,"updatedCells":170}} */
    console.log(`Completed ${resp.updates.updatedRows} updates with ${resp.updates.updatedColumns} datapoints`);
    return true;
  }
  catch (e) {
    console.error('appendAndClear failed', e);
    return false;
  }
}

export default appendAndClear;
